import { startOfDay, subDays } from 'date-fns';
import { size } from 'lodash';

import { DateSource } from '@shared/app/scripts/services/date-source';
import { Domain } from '@shared/app/scripts/services/domain';
import { Sentry } from '@shared/app/scripts/services/sentry';
import { SettingsManager } from '@shared/app/scripts/services/settings-manager';
import { Utility } from '@core/app/scripts/services/utility';

export class DataFeed {
  attempt = 0;
  cacheKey = '';

  constructor(
    private $http: ng.IHttpService,
    private $q: ng.IQService,
    private dateFilter: ng.IFilterDate,
    private dateSource: DateSource,
    private domain: Domain,
    private settingsManager: SettingsManager,
    private sentry: Sentry,
    private utility: Utility,
  ) {}

  getFeed = (dateOffset = 0) => {
    const today = startOfDay(subDays(this.dateSource.now(), dateOffset));

    let date = this.dateFilter(today, 'yyyyMMdd');

    let url = `//${this.domain.sibling('feeds')}/${
      this.settingsManager.settings.uploadDirectory
    }/${date}/barc0001.txt${this.cacheKey ? '?version=' + this.cacheKey : ''}`;

    return this.$http.get(url).then((response) => {
      // @ts-ignore
      if (size(response.data) === 0) {
        return this.$q.reject();
      }

      return response;
    });
  };

  fallback = () => {
    this.sentry.captureMessage(
      'Failed to load current dataFeed, falling back to yesterday',
    );

    this.attempt += 1;

    return this.retryFeed();
  };

  retryFeed = () => {
    if (this.attempt > 6) {
      return this.$q.reject();
    }

    return this.getFeed(this.attempt).then((x) => x, this.fallback);
  };

  load = (reloadCache = false) => {
    if (reloadCache) {
      this.cacheKey = this.utility.uuid();
    }

    this.attempt = 0;

    return this.retryFeed();
  };
}

/*
 * Service dataFeed
 */
angular
  .module('v6CoreModule')
  .factory(
    'dataFeed',
    (
      $http: ng.IHttpService,
      $q: ng.IQService,
      dateFilter: ng.IFilterDate,
      dateSource: DateSource,
      domain: Domain,
      settingsManager: SettingsManager,
      sentry: Sentry,
      utility: Utility,
    ) => {
      return new DataFeed(
        $http,
        $q,
        dateFilter,
        dateSource,
        domain,
        settingsManager,
        sentry,
        utility,
      );
    },
  );
